export const lexicographical = (valueA: any, valueB: any): number => {
  if (valueA === valueB) {
    return 0;
  } else {
    return valueA > valueB ? 1 : -1;
  }
};
